import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
import { ErrorBoundary } from './components/ErrorBoundary';
(function initGoogleAdsTag() {
  const GTAG_ID = 'AW-1034862903';
  if (typeof window === 'undefined') return;
  if (document.getElementById('gtag-src')) return;
  const script = document.createElement('script');
  script.id = 'gtag-src';
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GTAG_ID}`;
  document.head.appendChild(script);
  (window as any).dataLayer = (window as any).dataLayer || [];
  function gtag(...args: any[]) {
    ;
    (window as any).dataLayer.push(args);
  }
  ;
  (window as any).gtag = gtag;
  gtag('js', new Date());
  gtag('config', GTAG_ID);
})();
render(<ErrorBoundary data-id="element-2253">
    <App data-id="element-2254" />
  </ErrorBoundary>, document.getElementById('root'));